import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const AiWritingIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			fillRule="evenodd"
			d="m4.424 1.883-.32 1.594c-.037.189-.056.284-.103.36A.5.5 0 0 1 3.837 4c-.076.047-.171.066-.36.104l-1.594.318a1.098 1.098 0 0 0 0 2.154l1.594.318c.189.038.284.057.36.104A.5.5 0 0 1 4 7.163c.047.076.066.171.104.36l.318 1.594a1.098 1.098 0 0 0 2.154 0l.318-1.594c.038-.189.057-.284.104-.36A.5.5 0 0 1 7.163 7c.076-.047.171-.066.36-.104l1.594-.318a1.098 1.098 0 0 0 0-2.153l-1.594-.32c-.189-.037-.284-.056-.36-.103A.5.5 0 0 1 7 3.837c-.047-.076-.066-.171-.104-.36l-.318-1.594a1.098 1.098 0 0 0-2.153 0m10.171 4.521a1.38 1.38 0 0 0-1.952 0l-.192.193a.265.265 0 0 0 .049.406 5.4 5.4 0 0 1 1.497 1.487c.091.141.292.172.41.053l.188-.187a1.38 1.38 0 0 0 0-1.952M11.369 7.68a.2.2 0 0 1 .232-.043c.272.133.583.344.876.61.395.356.706.76.877 1.145.04.088.015.19-.053.258l-4.267 4.268a3.72 3.72 0 0 1-2.399 1.08.598.598 0 0 1-.634-.633 3.72 3.72 0 0 1 1.081-2.399z"
			clipRule="evenodd"
		></path>
	</svg>
))
